<template>
    <div class="reveal hpPros">
        <div class="container">
            <div class="split-text title"><p>SPEAKERS</p></div>
            <!--<div class="split-text subtitle"><p>We are so excited to invite you and your clients to join us for the MIS Conference, taking place on the beautiful beaches of Cancun, Mexico, at the luxurious Hilton all-inclusive resort.</p></div>        -->
        </div>
        <div class="xrImgCircleItems">
            <div style="--index:0" class="xrImgCircle"><div class="xrImg" style="background-image: url('https://www.mis-implants.com/upload/Education/MIS-Academy/Our-Speakers/Speakers/Wael_Att.jpg')"></div></div>
            <div style="--index:1" class="xrImgCircle"><div class="xrImg" style="background-image: url('https://www.mis-implants.com/upload/Education/MIS-Academy/Our-Speakers/Speakers/Nitzan_Bichacho.jpg')"></div></div>
            <div style="--index:2" class="xrImgCircle"><div class="xrImg" style="background-image: url('https://www.mis-implants.com/upload/Education/MIS-Academy/Our-Speakers/Speakers/Tali_Chackartchi.jpg')"></div></div>
            <div style="--index:3" class="xrImgCircle"><div class="xrImg" style="background-image: url('https://www.mis-implants.com/upload/Education/MIS-Academy/Our-Speakers/Speakers/Victor_Clavijo.jpg')"></div></div>
            <div style="--index:4" class="xrImgCircle"><div class="xrImg" style="background-image: url('https://www.mis-implants.com/upload/Education/MIS-Academy/Our-Speakers/Speakers/Mirela_Feraru.jpg')"></div></div>
            <div style="--index:5" class="xrImgCircle"><div class="xrImg" style="background-image: url('https://www.mis-implants.com/upload/Education/MIS-Academy/Our-Speakers/Speakers/Pablo_Galindo.jpg')"></div></div>
            <div style="--index:6" class="xrImgCircle"><div class="xrImg" style="background-image: url('https://www.mis-implants.com/upload/Education/MIS-Academy/Our-Speakers/Speakers/Pablo_Galindo.jpg')"></div></div>
            <div style="--index:7" class="xrImgCircle"><div class="xrImg" style="background-image: url('https://www.mis-implants.com/upload/Education/MIS-Academy/Our-Speakers/Speakers/Pablo_Galindo.jpg')"></div></div>
        </div>
        <!--
        <div class="xrBtn">
            <a href="/Products/MGUIDE" class="white_btn animation_up">
            <span class="title">Read More</span><i class="fal fa-chevron-right pl-s" ></i>
            </a>
        </div>
        -->
    </div>
</template>


<style>
    /* ------------ Active animations ------------*/
    /* ------------ Active animations ------------*/
    /* ------------ Active animations ------------*/
    .hpPros
    {
      width: 100%;
    }


    /* ------------ Active animations ------------*/
  .hpPros .xrImgCircleItems
  {
    display: grid;
    justify-items: center;
    grid-template-columns: repeat(4, minmax(115px, 1fr));  
    padding-top:30px;clear:both;
    margin:auto;
    width:70vw;
    max-width: 1200px;
  }
  .xrImgCircle
  {
    opacity: 0;
    clip-path: circle(50px at center);
    position: relative;
    background-color:rgba(255,255,255,0.15);
    width: 120px;height: 120px;
  }

  .xrImgCircle .xrImg
  {
    opacity: 1;
    position: absolute;
    width: 120px;height: 120px;
    background-size: 115%;
    background-color: #fff;
    background-repeat: no-repeat;
    background-position: center center;    
    clip-path: circle(40px at center);
    transition: all ease-in-out 0.3s;
  }
  .xrImgCircle:hover .xrImg
  {
    __clip-path: circle(35px at center);
  }
    .clip-circle {
    clip-path: circle(40px at center);
    /* OLD VALUE example: circle(245px, 140px, 50px); */
    /* Yep, even the new clip-path has deprecated stuff. */
    }


  @keyframes cirImgOpenBase {
    from {clip-path: circle(1px at center);opacity: 0;}  
    to {transform: circle(50px at center);opacity: 1;}
  }  
  @keyframes cirImgOpen {
    from {clip-path: circle(1px at center);opacity: 0;}  
    to {transform: circle(40px at center);opacity: 1;}
  }  
  @keyframes xSlideTextUp {
    from {transform: translateY(40px);opacity: 0;}  
    to {transform: translateY(0);opacity: 1;}
  }
  @keyframes xSlideBtnUp {
    from {transform: translateY(20px);opacity: 0;}  
    to {transform: translateY(0);opacity: 1;}
  }

  .animation_up{
    opacity:0;
  }
  .white_btn
  {
    opacity:0;
    cursor: pointer;
    position: relative;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start;
    color: #fff !important;
    border: 1px solid #ddd;
    text-align: left;
    background-color:transparent;
    padding: 25px 25px;
    border-radius: 40px;
    height: 40px;
    font-size: 14px;
  }
  .white_btn span
  {
    line-height: 1;
    display: inline-block;
    vertical-align: middle;    
  }
  .xrBtn
  {
    padding-top:20px;color:#fff;width:50%;margin:auto;text-align:center;
  }
</style>


<script>
import { mapActions, mapState } from "vuex";
import { splitLines }         from "@/utils";

export default {
  name: "hpPros",
  mounted() {
  },
  methods: {
  },
  computed: {
    ...mapState(["pageLayoutData", "locale", "dirtyHome"]),
  }
};
</script>

